
interface TabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function TabBar({ activeTab, setActiveTab }: TabBarProps) {
  const tabs = [
    { id: 'playlist', label: 'Playlist', icon: 'ri-play-list-fill' },
    { id: 'manage', label: 'Manage', icon: 'ri-folder-music-fill' },
    { id: 'recommendations', label: 'Discover', icon: 'ri-compass-fill' },
    { id: 'subscribers', label: 'Followers', icon: 'ri-user-heart-fill' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 border-t border-stone-800/60 bg-stone-950/95 backdrop-blur-xl md:hidden">
      <div className="grid grid-cols-4 px-1 py-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center justify-center rounded-2xl py-2 px-2 transition-colors ${
              activeTab === tab.id
                ? 'bg-white/10 text-amber-300'
                : 'text-stone-400 hover:text-stone-200'
            }`}
          >
            <div className="w-5 h-5 flex items-center justify-center mb-1">
              <i className={`${tab.icon} text-base`}></i>
            </div>
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
